import { render, staticRenderFns } from "./rukudanmingxi.vue?vue&type=template&id=ec5ea01c&scoped=true&"
import script from "./rukudanmingxi.vue?vue&type=script&lang=js&"
export * from "./rukudanmingxi.vue?vue&type=script&lang=js&"
import style0 from "./rukudanmingxi.vue?vue&type=style&index=0&id=ec5ea01c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5ea01c",
  null
  
)

export default component.exports